import { Component, EventEmitter, OnInit } from '@angular/core';
import { EnviarCorreo } from 'app/entidades/entidades';
import { CatUsuariosService } from '../../servicios/cat-usuarios.service';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MuestraMensaje } from 'app/shared/utilerias/notificaciones/notificaciones.component';
import { CatUsuarios} from '../../entidades/entidades';
import { async } from '@angular/core/testing';
import { AuthenticationService } from '../../servicios/authentication.service';
import { ObtenerUsuarioPorCargoService } from 'app/servicios/obtener-usuario-por-cargo.service';
import {CustomValidator } from '../../shared/utilerias/CustomValidator';



@Component({
  selector: 'app-cambiopass',
  templateUrl: './cambiopass.component.html',
  styleUrls: ['./cambiopass.component.css']
})
export class CambiopassComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  cambiopassForm: FormGroup;
  public contrasenia: string;
  contrasenia1: string;
  usuario: any;
  mostrarPassword: boolean[] = [false, false];

  constructor(
    private formBuilder: FormBuilder,
    private catUsuariosService: CatUsuariosService ,
    private authenticationService: AuthenticationService,
    private obtenerUsuarioPorCargoService: ObtenerUsuarioPorCargoService
  ) { }


  
  ngOnInit(){

    this.cambiopassForm = this.formBuilder.group({
      username :[undefined],
      contrasenia: [undefined,[Validators.required,CustomValidator.PasswordIsValid]],
      contrasenia1: [undefined,[Validators.required,CustomValidator.PasswordIsValid]]
   


    });
    this.usuario = this.authenticationService.currentUserValue;
  }

  togglePassword(index: number) {
    this.mostrarPassword[index] = !this.mostrarPassword[index];
  }
  
  async cambioContrasenya() {
    try {

      this.contrasenia = this.cambiopassForm.value.contrasenia;
      this.contrasenia1 = this.cambiopassForm.value.contrasenia1;
      
      if (this.contrasenia != this.contrasenia1 )
        throw new Error('LAS CONTRASEÑAS NO CONCIDEN');

      let catUsuarios = new CatUsuarios();
      catUsuarios.contrasenia = this.contrasenia;
      catUsuarios.fechaBaja = new Date(Date.now());
      catUsuarios.fechaAlta = new Date(Date.now());
      catUsuarios.idEstatus = 1;
    

      const datoRetorno  = await this.catUsuariosService.actualizaSoloContraseña(catUsuarios).toPromise();

     if (datoRetorno)
       this.muestraMensaje.notification('Cambio de contraseña Éxitoso', "top", "center");
      
    }catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {

    }
  }
  async isLoggedIn(){      
    let status = false;      
    if (localStorage.getItem('isLoggedIn') == "true") {      
       status = true;      
    }    
    else {      
       status = false;      
       }      
    return status;      
    }    
 
}